import { useEffect, useState } from "react";

// react-bootstrap
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Alert from "react-bootstrap/Alert";

//api calls
import { useSampleEdit, getApiErrorInfo } from "./../../api";
import { ErrorText } from "../ui/ErrorReference";

export default function Notes({ sampleNotes, id, onDirtyChange }) {
  const [notes, setNotes] = useState(sampleNotes);
  const [isSaved, setIsSaved] = useState(true);
  const [error, setError] = useState("");

  const { mutateAsync, isLoading: editLoading } = useSampleEdit(id);

  async function handleNotesSave() {
    setError("");
    try {
      if (notes !== sampleNotes) {
        await mutateAsync({ id: id, data: { description: notes } });
      }
      setIsSaved(true);
    } catch (err) {
      // Stay in edit mode so the typed notes aren't lost.
      setError(getApiErrorInfo(err, "Failed to save notes. Please try again."));
    }
  }

  function handleCancel() {
    setNotes(sampleNotes);
    setIsSaved(true);
    setError("");
  }

  useEffect(() => {
    setNotes(sampleNotes);
    setIsSaved(true);
    setError("");
  }, [id, sampleNotes]);

  useEffect(() => {
    const hasChanges = !isSaved && notes !== sampleNotes;
    onDirtyChange?.(hasChanges);
  }, [isSaved, notes, sampleNotes, onDirtyChange]);

  return (
    <div className='my-2 full-height'>
      <div className='card full-height'>
        <div className='card-body'>
          <Form>
            <div className='d-flex justify-content-between mb-2 gap-2'>
              <Form.Label className='h5 card-title text-primary'>
                Notes
              </Form.Label>
              {/* if the notes are saved, show the edit button, else show the save and cancel buttons */}
              {isSaved ? (
                <Button
                  variant='secondary'
                  type='submit'
                  onClick={(e) => {
                    e.preventDefault();
                    setIsSaved(false);
                  }}
                >
                  Edit
                </Button>
              ) : (
                <div className='d-flex gap-2'>
                  <Button
                    variant='outline-primary'
                    type='submit'
                    disabled={editLoading || notes === sampleNotes}
                    onClick={(e) => {
                      e.preventDefault();
                      handleNotesSave();
                    }}
                  >
                    {editLoading ? "Saving..." : "Save"}
                  </Button>
                  <Button
                    variant='outline-secondary'
                    type='submit'
                    disabled={editLoading}
                    onClick={(e) => {
                      e.preventDefault();
                      handleCancel();
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              )}
            </div>
            {error && (
              <Alert
                variant='danger'
                className='mb-2'
                onClose={() => setError("")}
                dismissible
              >
                <ErrorText error={error} />
              </Alert>
            )}

            <Form.Control
              as={"textarea"}
              rows={6}
              placeholder='Enter notes here'
              value={notes}
              disabled={isSaved}
              style={{ opacity: `${isSaved ? "0.6" : ""}` }}
              onChange={(e) => setNotes(e.target.value)}
            />
          </Form>
        </div>
      </div>
    </div>
  );
}
